const FloatingShapes = ({ variant = "default" }: { variant?: "default" | "alt" | "sparse" }) => {
  const shapes = {
    default: (
      <>
        {/* Circles */}
        <div className="absolute top-[8%] left-[6%] w-20 h-20 rounded-full border border-white/[0.07] animate-float" />
        <div className="absolute top-[18%] right-[22%] w-8 h-8 rounded-full bg-white/[0.04] animate-bounce-slow" style={{ animationDelay: "1s" }} />
        <div className="absolute top-[55%] right-[10%] w-14 h-14 rounded-full border border-primary-400/[0.08] animate-bounce-slow" />
        <div className="absolute bottom-[18%] left-[18%] w-6 h-6 rounded-full bg-white/[0.05] animate-float" style={{ animationDelay: "2s" }} />
        <div className="absolute top-[35%] left-[48%] w-10 h-10 rounded-full border border-secondary-400/[0.06] animate-float" style={{ animationDelay: "4s" }} />
        <div className="absolute bottom-[8%] right-[40%] w-5 h-5 rounded-full bg-primary-300/[0.06] animate-bounce-slow" style={{ animationDelay: "3s" }} />

        {/* Triangles */}
        <svg className="absolute top-[22%] right-[16%] w-14 h-14 text-white/[0.06] animate-wiggle" viewBox="0 0 24 24" fill="currentColor">
          <polygon points="12,2 22,20 2,20" />
        </svg>
        <svg className="absolute bottom-[28%] left-[32%] w-8 h-8 text-primary-300/[0.06] animate-bounce-slow" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "1s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>
        <svg className="absolute top-[68%] left-[8%] w-10 h-10 text-white/[0.04] animate-wiggle" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "3.5s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>
        <svg className="absolute top-[12%] left-[55%] w-6 h-6 text-secondary-300/[0.05] animate-float" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "2.5s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>

        {/* Hexagons */}
        <svg className="absolute top-[42%] left-[4%] w-16 h-16 text-white/[0.05] animate-wiggle" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "3s" }}>
          <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
        </svg>
        <svg className="absolute bottom-[12%] right-[7%] w-12 h-12 text-secondary-400/[0.06] animate-float" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "1.5s" }}>
          <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
        </svg>
        <svg className="absolute top-[75%] right-[28%] w-8 h-8 text-primary-400/[0.05] animate-bounce-slow" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "4.5s" }}>
          <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
        </svg>

        {/* Diamonds */}
        <div className="absolute top-[65%] right-[30%] w-10 h-10 border border-white/[0.06] rotate-45 animate-bounce-slow" style={{ animationDelay: "2.5s" }} />
        <div className="absolute top-[30%] left-[25%] w-6 h-6 border border-primary-300/[0.05] rotate-45 animate-float" style={{ animationDelay: "5s" }} />
        <div className="absolute bottom-[35%] right-[50%] w-4 h-4 bg-white/[0.03] rotate-45 animate-wiggle" style={{ animationDelay: "1.5s" }} />

        {/* Rings */}
        <div className="absolute top-[48%] right-[42%] w-18 h-18 rounded-full border-2 border-white/[0.03] animate-float" style={{ animationDelay: "2s" }} />
        <div className="absolute bottom-[5%] left-[42%] w-12 h-12 rounded-full border border-dashed border-white/[0.04] animate-wiggle" style={{ animationDelay: "3.5s" }} />
      </>
    ),
    alt: (
      <>
        {/* Circles */}
        <div className="absolute top-[8%] right-[8%] w-24 h-24 rounded-full border border-white/[0.06] animate-float" style={{ animationDelay: "1s" }} />
        <div className="absolute bottom-[22%] left-[12%] w-10 h-10 rounded-full bg-primary-400/[0.05] animate-bounce-slow" style={{ animationDelay: "0.5s" }} />
        <div className="absolute top-[38%] right-[35%] w-6 h-6 rounded-full bg-white/[0.04] animate-float" style={{ animationDelay: "3s" }} />
        <div className="absolute top-[15%] left-[28%] w-8 h-8 rounded-full border border-secondary-300/[0.06] animate-bounce-slow" style={{ animationDelay: "2s" }} />
        <div className="absolute bottom-[10%] left-[50%] w-14 h-14 rounded-full border border-white/[0.05] animate-float" style={{ animationDelay: "4.5s" }} />
        <div className="absolute top-[72%] left-[5%] w-5 h-5 rounded-full bg-primary-300/[0.06] animate-wiggle" style={{ animationDelay: "1.5s" }} />

        {/* Triangles */}
        <svg className="absolute top-[35%] left-[8%] w-12 h-12 text-white/[0.05] animate-wiggle" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "2s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>
        <svg className="absolute bottom-[8%] right-[22%] w-16 h-16 text-secondary-300/[0.05] animate-float" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "3.5s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>
        <svg className="absolute top-[60%] right-[15%] w-7 h-7 text-white/[0.04] animate-bounce-slow" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "5s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>
        <svg className="absolute top-[5%] left-[45%] w-9 h-9 text-primary-300/[0.04] animate-wiggle" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "1s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>

        {/* Hexagons */}
        <svg className="absolute top-[18%] left-[38%] w-14 h-14 text-white/[0.04] animate-bounce-slow" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "1.5s" }}>
          <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
        </svg>
        <svg className="absolute top-[58%] right-[4%] w-10 h-10 text-primary-300/[0.06] animate-wiggle" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "2.5s" }}>
          <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
        </svg>
        <svg className="absolute bottom-[30%] left-[22%] w-8 h-8 text-secondary-400/[0.05] animate-float" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "4s" }}>
          <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
        </svg>

        {/* Diamonds */}
        <div className="absolute top-[45%] left-[22%] w-8 h-8 border border-white/[0.05] rotate-45 animate-float" style={{ animationDelay: "4s" }} />
        <div className="absolute bottom-[18%] right-[45%] w-5 h-5 border border-primary-300/[0.05] rotate-45 animate-bounce-slow" style={{ animationDelay: "2s" }} />
        <div className="absolute top-[25%] right-[48%] w-4 h-4 bg-white/[0.03] rotate-45 animate-wiggle" style={{ animationDelay: "3s" }} />

        {/* Rings */}
        <div className="absolute bottom-[40%] right-[38%] w-16 h-16 rounded-full border-2 border-white/[0.03] animate-wiggle" style={{ animationDelay: "1s" }} />
      </>
    ),
    sparse: (
      <>
        {/* Circles */}
        <div className="absolute top-[15%] right-[12%] w-14 h-14 rounded-full border border-white/[0.06] animate-float" />
        <div className="absolute bottom-[20%] left-[8%] w-8 h-8 rounded-full bg-white/[0.04] animate-bounce-slow" style={{ animationDelay: "1.5s" }} />
        <div className="absolute top-[50%] left-[30%] w-6 h-6 rounded-full border border-primary-300/[0.06] animate-float" style={{ animationDelay: "3s" }} />
        <div className="absolute top-[30%] right-[40%] w-10 h-10 rounded-full border border-white/[0.05] animate-bounce-slow" style={{ animationDelay: "4s" }} />
        <div className="absolute bottom-[8%] left-[55%] w-5 h-5 rounded-full bg-secondary-300/[0.05] animate-wiggle" style={{ animationDelay: "2s" }} />

        {/* Triangles */}
        <svg className="absolute top-[40%] right-[5%] w-10 h-10 text-primary-300/[0.05] animate-bounce-slow" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "1s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>
        <svg className="absolute bottom-[35%] left-[45%] w-7 h-7 text-white/[0.04] animate-wiggle" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "3.5s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>
        <svg className="absolute top-[10%] left-[20%] w-8 h-8 text-secondary-300/[0.04] animate-float" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "2.5s" }}>
          <polygon points="12,2 22,20 2,20" />
        </svg>

        {/* Hexagons */}
        <svg className="absolute bottom-[22%] left-[8%] w-12 h-12 text-white/[0.05] animate-wiggle" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "2s" }}>
          <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
        </svg>
        <svg className="absolute top-[65%] right-[18%] w-9 h-9 text-primary-400/[0.05] animate-float" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "4s" }}>
          <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
        </svg>

        {/* Diamonds */}
        <div className="absolute bottom-[12%] right-[32%] w-7 h-7 border border-white/[0.05] rotate-45 animate-float" style={{ animationDelay: "3s" }} />
        <div className="absolute top-[25%] left-[50%] w-4 h-4 bg-white/[0.03] rotate-45 animate-bounce-slow" style={{ animationDelay: "5s" }} />

        {/* Ring */}
        <div className="absolute top-[70%] left-[15%] w-10 h-10 rounded-full border-2 border-white/[0.03] animate-float" style={{ animationDelay: "1.5s" }} />
      </>
    ),
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {shapes[variant]}
    </div>
  );
};

export default FloatingShapes;
